<template>
    <v-container >
            <v-card class="post-card" :href="item.link" target="_blank">
                <v-img :src="item.thumbnail" aspect-ratio="2.25" />
                <v-list-item class="text-left">
                    <v-list-item-avatar>
                        <v-img :src="feed.image"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{getTitle || item.title}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ getDate }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <p class="post-card__text text-left ma-2">
                        {{ getDescriptions }}
                    </p>
                </v-list-item>
            </v-card>
        <!-- <v-row justify="center">
        </v-row> -->
    </v-container>
</template>


<script>
export default {
    name: "PostCard",
    props: ["item", "feed", "minWidth"],
    data() {
        return {
        };

    },
    created() {
    },
    watch: {
    },
    computed: {
        getDate() {
            let date = new Date(this.item.pubDate.substring(0, 10)) ;
            let [day, month, year] = date.toLocaleDateString().split("-");
            return `Publicado el ${day}/${month}/${year}` ;
        },
        getTitle() {
            let parse = new DOMParser();
            return [...parse.parseFromString(this.item.content, "text/html").getElementsByTagName("h3")].map(p => p.innerText).join("\n");
        },
        getDescriptions() {
            let parse = new DOMParser();
            return [...parse.parseFromString(this.item.content, "text/html").getElementsByTagName("p")].map(p => p.innerText).join("\n");
        }
    },
    methods: {
    }
};
</script>

